import { render, staticRenderFns } from "./RequestNewEsgQuestionnaire.vue?vue&type=template&id=e9c3db82&scoped=true"
import script from "./RequestNewEsgQuestionnaire.vue?vue&type=script&setup=true&lang=ts"
export * from "./RequestNewEsgQuestionnaire.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./RequestNewEsgQuestionnaire.vue?vue&type=style&index=0&id=e9c3db82&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_babel-core@7.0.0-bridge.0_@babel+core@7.26.0__cache-loader@4.1.0_webpack@4_duly6tfyc62fvcli236pnhbyri/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9c3db82",
  null
  
)

/* custom blocks */
import block0 from "./RequestNewEsgQuestionnaire.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {IxFormInputStandardReferencePeriodSelect: require('/home/runner/work/assessment-service/assessment-service/frontend/components/ix/form-input/StandardReferencePeriodSelect.vue').default,IxFormInputDateRangePicker: require('/home/runner/work/assessment-service/assessment-service/frontend/components/ix/form-input/DateRangePicker.vue').default,IxButtonAction: require('/home/runner/work/assessment-service/assessment-service/frontend/components/ix/button/Action.vue').default,IxFormInputDatePicker: require('/home/runner/work/assessment-service/assessment-service/frontend/components/ix/form-input/DatePicker.vue').default,IxDialog: require('/home/runner/work/assessment-service/assessment-service/frontend/components/ix/Dialog.vue').default})
